import instance from '../api/interceptor';

export type PalabraLanguage = {
  id: number;
  code: string;
  name: string;
  imageUrl: string | null;
  welcomeMessage: string;
};

export type PalabraSession = {
  id?: number;
  publisher: string;
  subscriber?: string;
  webrtcUrl: string;
  webrtcRoomName: string;
  sessionId: string;
  callUuid: string;
  sourceLanguage: PalabraLanguage;
  targetLanguage: PalabraLanguage;
};

// Справочник за время жизни страницы не меняется, поэтому кэшируем сам промис:
// параллельные вызовы переиспользуют один запрос вместо того, чтобы плодить свои
let languagesPromise: Promise<PalabraLanguage[]> | null = null;

export const PalabraService = {
  // Справочник языков с их id — id генерятся на бэке, поэтому хардкодить их нельзя
  getLanguages(): Promise<PalabraLanguage[]> {
    if (!languagesPromise) {
      languagesPromise = instance
        .get('/languages')
        .then(({ data }) => data?.data ?? [])
        .catch((err) => {
          // сбрасываем, чтобы следующий вызов мог попробовать заново
          languagesPromise = null;
          throw err;
        });
    }

    return languagesPromise;
  },

  async createOnboardingSession(params: {
    sourceLanguageId: number;
    targetLanguageId: number;
  }): Promise<PalabraSession | null> {
    const { data } = await instance.post('/palabra/session-onboarding', {
      sourceLanguageId: params.sourceLanguageId,
      targetLanguageId: params.targetLanguageId,
      sessionType: 'conversation',
    });

    if (!data?.success || !data?.sessions?.length) {
      return null;
    }

    return data.sessions[0];
  },
};
